import useAuthStore from '../../store/useAuthStore'
import { useCityviseApartment } from '../../assets/api/useMarketingExecutive'
import CommonTermAndCondtion from '../commonfile/CommonTermAndCondtion'

const NewTCExecutive = () => {
    const { user } = useAuthStore()
    const { data: CityApartmentList, isLoading: isCityApartmentListLoading } = useCityviseApartment({ zone_id: user?.zone_id })
    return (
        <CommonTermAndCondtion apartmentRow={CityApartmentList?.data} isloadingApartment={isCityApartmentListLoading} />
    )
}

export default NewTCExecutive